(function () {
  function initSection(sectionEl) {
    if (!sectionEl || sectionEl.dataset.compareInit === 'true') return;
    if (typeof Swiper === 'undefined') return;

    var swiperEl = sectionEl.querySelector('.openear-compare-swiper');
    if (!swiperEl) return;

    sectionEl.dataset.compareInit = 'true';

    var prevButtons = sectionEl.querySelectorAll('.controls-inner .prev-btn');
    var nextButtons = sectionEl.querySelectorAll('.controls-inner .next-btn');
    var paginationEl = sectionEl.querySelector('.pagination');
    var totalSlides = swiperEl.querySelectorAll('.swiper-slide').length;
    var enableLoop = totalSlides > 1;

    function getRealIndex(swiperInstance) {
      if (!swiperInstance) return 0;
      if (typeof swiperInstance.realIndex === 'number' && swiperInstance.realIndex >= 0) {
        return swiperInstance.realIndex;
      }
      return typeof swiperInstance.activeIndex === 'number' ? swiperInstance.activeIndex : 0;
    }

    function stepCompare(delta) {
      if (!enableLoop || !delta) return;
      var lastIndex = Math.max(totalSlides - 1, 0);
      var currentIndex = getRealIndex(swiper);
      var targetIndex = delta > 0
        ? (currentIndex >= lastIndex ? 0 : currentIndex + 1)
        : (currentIndex <= 0 ? lastIndex : currentIndex - 1);

      if (swiper.params.loop) {
        swiper.slideToLoop(targetIndex, swiper.params.speed || 450, true);
        return;
      }

      swiper.slideTo(targetIndex, swiper.params.speed || 450, true);
    }

    var swiper = new Swiper(swiperEl, {
      slidesPerView: 'auto',
      spaceBetween: 24,
      slidesPerGroup: 1,
      slidesOffsetAfter: 10,
      loop: enableLoop,
      loopedSlides: enableLoop ? totalSlides : 0,
      loopAdditionalSlides: enableLoop ? totalSlides : 0,
      speed: 450,
      allowTouchMove: true,
      watchOverflow: true,
      centeredSlides: false,
      pagination: {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        0: {
          slidesPerView: 'auto',
          spaceBetween: 12,
          slidesPerGroup: 1,
          slidesOffsetBefore: 0,
          slidesOffsetAfter: 0
        },
        761: {
          slidesPerView: 'auto',
          spaceBetween: 24,
          slidesPerGroup: 1,
          slidesOffsetAfter: 10
        }
      },
      on: {
        init: function () {
          this.update();
        },
        resize: function () {
          this.update();
        }
      }
    });

    if (prevButtons.length) {
      prevButtons.forEach(function (prevBtn) {
        prevBtn.addEventListener('click', function () {
          stepCompare(-1);
        });
      });
    }

    if (nextButtons.length) {
      nextButtons.forEach(function (nextBtn) {
        nextBtn.addEventListener('click', function () {
          stepCompare(1);
        });
      });
    }

    sectionEl.addEventListener('click', function (event) {
      var learnMoreLink = event.target.closest('.learn-more');
      if (!learnMoreLink || !sectionEl.contains(learnMoreLink)) return;

      var buttonName = learnMoreLink.textContent ? learnMoreLink.textContent.trim() : 'Meer informatie';

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event_parameters: null });
      window.dataLayer.push({
        event: 'ga4Event',
        event_name: 'select_content',
        event_parameters: {
          button_name: buttonName
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.section-openear-compare').forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var section = event.target.querySelector('.section-openear-compare');
    if (section) initSection(section);
  });
})();
